<template>
    <div>
        <v-card class="rounded-lg" elevation="0" color="#41916b">
            <v-card-title class="text-center justify-center" v-if="isEdit">
                <h5 class="font-weight-bold" style="color: white">
                    {{ donorLabel }}
                </h5>
            </v-card-title>

            <v-tabs v-model="tab" fixed-tabs background-color="#41916b" dark>
                <v-tabs-slider color="#b1e3cc"></v-tabs-slider>
                <v-tab>{{ title }}</v-tab>

                <v-tab-item>
                    <v-card-text>
                        <div class=""
                            style="border: solid 1px #e1e3e2; border-radius: 15px; padding: 10px; width: 100%;">
                            <v-form @submit.prevent="createSerology" ref="form" :disabled="disableForm">
                                <p style="font-weight:bold">Potencial Doador:</p>
                                <v-row>
                                    <v-col class="d-flex" cols="12" sm="3" v-if="!isEdit">
                                        <v-autocomplete :rules="formRules" :items="donor" color="#256936"
                                            class="rounded-lg" v-model="serologyForm.donor_id" item-value="id"
                                            item-text="name" dense outlined label="Paciente/Potencial Doador"
                                            no-data-text="Não há pacientes para cadastro"
                                            @change="checkIfHasBloodGroup(serologyForm.donor_id)">
                                        </v-autocomplete>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="3" v-if="!hasTwoPermissions">
                                        <v-text-field color="#256936" :rules="formRules" class="rounded-lg" label="CPF"
                                            :disabled="selectedCpf" outlined :value="selectedCpf" maxlength="14" v-mask="'###.###.###-##'"
                                            dense></v-text-field>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="3">
                                        <v-text-field color="#256936" class="rounded-lg" :rules="formRules"
                                            label="Nº do Laudo/AAAA" outlined v-model="serologyForm.report_number"
                                            dense></v-text-field>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="3">
                                        <v-text-field color="#086318" class="rounded-lg" :rules="formRules"
                                            :max="maxDate" label="Data da Coleta de Amostra" type="date"
                                            @input="onlyDateInput('sample_date', $event)" outlined
                                            v-model="serologyForm.sample_date" dense></v-text-field>
                                    </v-col>
                                </v-row>
                                <p style="font-weight:bold">Responsável pelos Exames:</p>
                                <v-row>
                                    <v-col class="d-flex" cols="12" sm="3">
                                        <v-text-field color="#256936" class="rounded-lg" :rules="formRules"
                                            label="Nome do Responsável" outlined v-model="serologyForm.responsible_name"
                                            dense></v-text-field>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="3">
                                        <v-text-field color="#256936" class="rounded-lg" :rules="formRules"
                                            label="Conselho" outlined v-model="serologyForm.advice"
                                            dense></v-text-field>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="3">
                                        <v-text-field color="#256936" class="rounded-lg" type="datetime-local"
                                            @input="onDateTimeInput('release_date', $event)" :max="maxDateTime"
                                            :rules="formRules" label="Data e Horário da Liberação" outlined
                                            v-model="serologyForm.release_date" dense></v-text-field>
                                    </v-col>
                                </v-row>
                                <p style="font-weight:bold">Tipo de Exame:</p>
                                <v-row style="padding-left:10px" class="mb-2">
                                    <v-radio-group :rules="formRules" row v-model="serologyForm.type_report_id">
                                        <v-radio label="Córnea" value="1" color="#086318"></v-radio>

                                        <v-radio label="Esclera" value="2" color="#086318"></v-radio>

                                        <v-radio label="Múltiplos Orgãos" value="3" color="#086318"></v-radio>
                                    </v-radio-group>
                                </v-row>
                                <p style="font-weight:bold">Sorologia:</p>

                                <v-row dense>
                                    <v-col class="d-flex" cols="12" sm="4" v-for="(serology, index) in serologyList"
                                        :key="index" dense>
                                        <v-select
                                            :items="serology.type_serology_status_id == '1' ? serologyTypeOneItems : serologyTypeTwoItems"
                                            class="rounded-lg" color="#256936" v-model="serology.serology_status_id"
                                            item-value="id" item-text="name" dense outlined
                                            :label="serology.description">
                                        </v-select>
                                    </v-col>
                                </v-row>

                                <v-row class="buttons pa-3 d-flex justify-center" v-if="disableForm == false">
                                    <v-btn class="rounded-lg mr-1" elevation="0" type="submit" color="#41916b">
                                        <span style="color: aliceblue;">{{ isEdit ? 'Atualizar' : 'Salvar' }}</span>
                                    </v-btn>
                                    <p class="space-personalized"></p>
                                    <v-btn class="rounded-lg mr-1" elevation="0" color="#96af9c"
                                        :loading="clearLoadingButton" @click="clearForm()">
                                        <span style="color: aliceblue;">{{$t('buttons.clean_up')}}</span>
                                    </v-btn>
                                    <p class="space-personalized"></p>
                                    <v-btn class="rounded-lg" elevation="0" color="grey"
                                        @click="$router.push('/sorologia')">
                                        <span style="color: aliceblue;">{{$t('buttons.return')}}</span>
                                    </v-btn>
                                </v-row>
                            </v-form>
                        </div>
                    </v-card-text>
                </v-tab-item>
            </v-tabs>
        </v-card>
    </div>
</template>
<script>
import axios from "@/axios";
import { mapActions, mapGetters } from "vuex"; 
import dateTimeLimit from "@/utils/dateTimeLimit";
import currentUser from "@/utils/currentUser";
import { profileSlug } from "@/helpers/profileSlug";
export default {
    data() {
        return {
            tab: 1,
            serologyList: [],
            serologyTypeOneItems: [],
            serologyTypeTwoItems: [],
            serologyForm: {},

            donor: [],
            items: [],
            blood_group_id: '',
            formRules: [
                (v) => !!v || "Este campo é obrigatório",
            ],
            disableForm: this.profile_slug == 'tec_hemoba_imuno' ? true : false,
            clearLoadingButton: false,
            disableCPF: true,
        }
    },

    props: {
        bloodGroupId: Number
    },

    async created() {
        await this.getFields();

        if (this.serologyDonor) {
            await this.fillForm(this.serologyDonor)
        }
    },

    computed: {
        ...mapGetters({
            patientDonorId: "getDonorId",
            serologyDonor: "getSorologyPatientData"
        }),

        isEdit() {
            return this.serologyDonor.id
        },

        title() {
            return this.isEdit ? 'Editar Sorologia' : 'Cadastrar Sorologia'
        },

        donorLabel() {
            const { kind_of_donor, name } = this.serologyDonor;

            return `Paciente ${kind_of_donor.name} - ${name}`;
        },

        donorCPF() {
            const { cpf } = this.serologyDonor;

            return `CPF: ${cpf}`
        },

        currentUser() {
            return currentUser.getUserData()
        },

        hasTwoPermissions() {
            return this.can('cad_serology' && 'cad_blood_group');
        },
        abilities() {
            return this.currentUser.abilities || []
        },
        maxDateTime() {
            const now = new Date()
            return now.toISOString().slice(0, 16)
        },
        maxDate() {
            const now = new Date()
            return now.toISOString().slice(0, 10)
        },

        profile() {
            return this.currentUser.profile
        },

        profile_slug() {
            return profileSlug(this.profile)
        },

        selectedCpf() {
            if(this.isEdit) return this.serologyDonor.cpf || null
            
            if(!this.donor || !this.serologyForm.donor_id) return null
            const donor = this.donor.find(x => x.id == this.serologyForm.donor_id)
            return donor ? donor.cpf : null
        }
    },

    methods: {
        ...mapActions([
            "changeSnackBarData"
        ]),

        can(ability) {
            return this.abilities.includes(ability)
        },
        onlyDateInput(path, field, value) {
            this[path][field] =
                dateTimeLimit.limiteInputOnlyDate(value)
        },
        onDateTimeInput(field, value) {
            this.serologyForm[field] =
                dateTimeLimit.limitYearField(value)
        },

        async getFields() {
            axios.get(`/serology_status/list`, {
                params: {
                    type_serology_status_id: '1'
                }
            }).then((response) => {
                this.serologyTypeOneItems = response.data.data ? response.data.data : response.data
            }),

                axios.get(`/serology_status/list`, {
                    params: {
                        type_serology_status_id: '2'
                    }
                }).then((response) => {
                    this.serologyTypeTwoItems = response.data.data ? response.data.data : response.data
                })

            await axios.get(`serology_tests/list`, {
                params: {
                    type_serology_status_id: ''
                }
            }).then((response) => {
                this.serologyList = response.data.data ? response.data.data : response.data
            })

            const donorRes = await axios.get(`/donor/no_serology`);
            this.donor = donorRes.data.data ? donorRes.data.data : donorRes.data;

        },

        async createSerology() {
            if (!this.$refs.form.validate()) return;

            this.loading = true;

            try {
                const donor_id =
                    this.serologyDonor?.id ??
                    this.serologyForm.donor_id ??
                    this.patientDonorId ??
                    null;

                const blood_group_id = this.serologyDonor?.blood_groups?.[0]?.id ??
                    this.bloodGroupId ??
                    null;

                const data = {
                    user_id: this.currentUser.id,
                    donor_id,
                    type_report_id: this.serologyForm.type_report_id,
                    blood_group_id,
                    report_number: this.serologyForm.report_number,
                    sample_date: this.serologyForm.sample_date,
                    release_date: this.formatDateTimeToBackend(this.serologyForm.release_date),
                    responsible_name: this.serologyForm.responsible_name,
                    advice: this.serologyForm.advice
                };

                const serologyItens = this.serologyList
                    .filter(item => item.serology_status_id)
                    .map(item => ({
                        id: this.serologyForm.id ? item.serologyItemId : undefined,
                        serology_test_id: item.id,
                        serology_status_id: item.serology_status_id
                    }));

                if (serologyItens.length) {
                    data.status_serology_tests = serologyItens;
                }

                const response = await axios({
                    method: this.serologyForm.id ? 'PUT' : 'POST',
                    url: this.serologyForm.id
                        ? `/serology/${this.serologyForm.id}`
                        : `/serology/create`,
                    data
                });

                this.changeSnackBarData({
                    status: true,
                    type: 'success',
                    titleMessage: response.data.message,
                    bodyMessage: '',
                    cardColor: '#41916b',
                    titleIcon: 'mdi-checkbox-marked-circle'
                });

                setTimeout(() => {
                    this.closeSnackBar();
                    this.$router.push('/sorologia')
                }, 3000);

            } catch (err) {

                this.changeSnackBarData({
                    status: true,
                    type: 'error',
                    titleMessage: 'Erro ao salvar sorologia',
                    bodyMessage: err.details || '',
                    cardColor: 'red',
                    titleIcon: 'mdi-close-circle'
                });

                setTimeout(() => this.closeSnackBar(), 5000);

            } finally {
                this.loading = false;
            }
        },

        formatDateTimeToBackend(value) {
            if (!value) return null;
            return value.replace("T", " ").slice(0, 16);
        },

        formatDateForInput(dateTime) {
            return dateTime.split(" ")[0];
        },

        checkIfHasBloodGroup(id) {
            axios.get(`blood_groups/list/${id}`).then((response) => {
                this.blood_group_id = response.data[0].id ? response.data[0].id : null
            })
        },

        fillForm() {
            let serolgy = this.serologyDonor.serology[0];

            if (!serolgy) {
                this.$nextTick(() => {
                    this.$set(this.serologyForm, 'donor_id', parseInt(this.serologyDonor.user_id))
                })
            } else {

                this.serologyForm = serolgy
                this.$nextTick(() => {
                    this.serologyForm.donor_id = parseInt(this.serologyDonor.id)
                    this.serologyForm.sample_date = this.formatDateForInput(this.serologyForm.sample_date)

                    const existing = serolgy.status_serology_tests

                    this.serologyList = this.serologyList.map(item => {
                        const found = existing.find(
                            x => x.serology_test.id === item.id
                        )

                        return {
                            ...item,
                            serology_status_id: found ? found.serology_status.id : null,
                            serologyItemId: found ? found.id : undefined,
                            type_serology_status_id: found
                                ? parseInt(found.serology_status.type_serology_status_id)
                                : item.type_serology_status_id
                        }
                    })
                })
            }
        },

        clearForm() {
            this.clearLoadingButton = true;
            this.serologyForm = {
                donor_id: null,
                report_number: null,
                sample_date: null,
                responsible_name: null,
                advice: null,
                release_date: null,
                type_report_id: null
            };
            this.serologyList = this.serologyList.map(item => ({
                ...item,
                serology_status_id: null
            }));

            this.blood_group_id = null;

            if (this.$refs.form) {
                this.$refs.form.reset();
                this.$refs.form.resetValidation();
            }

            setTimeout(() => {
                this.clearLoadingButton = false;
            }, 1000);
        },

        closeSnackBar() {
            this.changeSnackBarData({
                status: false,
                type: '',
                titleMessage: '',
                bodyMessage: '',
                cardColor: '',
                titleIcon: '',
            });
        },
    }
}
</script>
